import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';

import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';

import { AuthServiceProvider } from '../../providers/auth-service/auth-service';

import {BusquedaPage} from '../../pages/busqueda/busqueda'

/**
 * Generated class for the CarteraPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cartera',
  templateUrl: 'cartera.html',
})
export class CarteraPage {

  conceptos: any ;

  auxgenerar :  {idempresa: Number, id:Number, idestado:Number,  idconcepto: string, fecha: String, descripcion: String, detalle:any};

  auxCartera: any= [];

  loading: any;
  detalleBusqueda: any;

  listaMedida:any;
  

  constructor(public navCtrl: NavController, public navParams: NavParams
  	, public carteraService: CarteraServiceProvider
  	, public alertCtrl: AlertController
  	, public loadingCtrl: LoadingController
    , public authService : AuthServiceProvider
    ,public modalCtrl: ModalController
  	) {
  

  this.auxgenerar = {
      idempresa:1, idestado:0, id:0  , idconcepto: "1", fecha: new Date().toISOString(), descripcion:'', detalle:[]
    };


    this.carteraService.getMedida().then((resultado) => {
      this.listaMedida= resultado;
    });
   

  }


  ionViewDidLoad() {

  	this.carteraService.getConcepto()
    .then(data => {
      this.conceptos = data;
    });
  }

  imprimir(){
    this.carteraService.getReporte(1, this.authService.usuario['identidad'])
    .then(data=>{
      
      console.log(data)
    })


    window.open("http://localhost:3000/prueba.pdf", "_blank");
    
    
  }


  botonBuscar(){
    this.carteraService.getGCartera(1,0).then((result) => {
      console.log(result);
      this.detalleBusqueda={'parametro':result, 'campobus':'fecha,concepto,descripcion,total'};
      let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
      myModal.onDidDismiss(data => {
        if (data != null) {
          this.auxgenerar=data;
          this.carteraService.getGCartera(1, this.auxgenerar.id).then((resultd) => {
              this.auxgenerar.detalle= resultd;
              for (var i = 0; i < this.auxgenerar.detalle.length; ++i) {
                this.auxgenerar.detalle[i].cantidad = parseFloat(this.auxgenerar.detalle[i].cantidad).toFixed(2);
                this.auxgenerar.detalle[i].cantidadmedida = parseFloat(this.auxgenerar.detalle[i].cantidadmedida).toFixed(2);
              }
          });
        }
      });
      myModal.present();
    },
    (err) => {
      console.log(err);
    });
  }



  generarCartera(){
    let cantidadAuxiliar= this.conceptos.filter(p=> p.id==this.auxgenerar.idconcepto)[0].mcantidad;
    let idmedidax = this.conceptos.filter(p=> p.id==this.auxgenerar.idconcepto)[0].idmedida;

    // this.listaMedida.filter( p => p.id==this.auxgenerar.idconcepto )[0].cantidad  ;

  	this.auxgenerar.detalle=[];
  	this.carteraService.getCartera()
    .then(data => {
    console.log(data)
      for (let datoactual in data)
      {
      		this.auxgenerar.detalle.push
      		 (
      			{
              id:0,
              idgcartera:0,
      				idempresa:1,
      				idestado:0,
      				idtcartera:1,
      				fechaini:this.auxgenerar.fecha,
      				fechacar:this.auxgenerar.fecha,
      				observacion:'Ninguno',
      				idmovimiento:null,
      				cantidad:this.auxgenerar.idconcepto=="1"? parseFloat(data[datoactual].valalicuota).toFixed(2) :0,
              cantidadmedida: cantidadAuxiliar,
      				idmedida: idmedidax,
      				idconcepto: this.auxgenerar.idconcepto,
      				iddepartamento:data[datoactual].id,
      				identidad:data[datoactual].identidad,
      				descripcion: data[datoactual].descripcion,
      				entidad:data[datoactual].entidad,
      				ndepartamento:data[datoactual].ndepartamento,
      		 		pagar: (this.auxgenerar.idconcepto=="1" && data[datoactual].valalicuota > 0),
      		 		valdeuda: 0 ,
      		 		valpagado:0
      		 	}
      		 );
      }
      console.log(this.auxCartera)
    });
  	
  }

  guardarCartera(){

    this.auxgenerar.detalle.forEach(e => e.fechaini = this.auxgenerar.fecha )
    this.auxgenerar.detalle.forEach(e => e.fechacar = this.auxgenerar.fecha )
    this.auxgenerar.detalle.forEach(elemento => elemento.valdeuda= elemento.cantidadmedida* elemento.cantidad );

    
    
  	//let auxiliar= this.auxgenerar.detalle;

    this.auxgenerar.detalle= this.auxgenerar.detalle.filter(p=> p.pagar==true && p.valdeuda!=0);

  	
  	this.carteraService.addCartera(this.auxgenerar).then((result) => 
  	{
  		console.log(result);
  		this.showLoader('Se guardó correctamente!!',1000);
  		this.limpiar();
  		
 	 },
 	  (err) => {
    	console.log(err);
    	let alert = this.alertCtrl.create({
          title: 'Sistema condominios',
          subTitle: 'Problemas al generar la cartera!!',
          buttons: ['Aceptar']
        });
        alert.present();
  	 });

      
     
  	 
  }
  showLoader(mensaje,tiempo){
 
        this.loading = this.loadingCtrl.create({
            content: mensaje,
            duration: tiempo,
            spinner: 'hide'
        });
 
        this.loading.present();

       this.loading.onDidDismiss(() => {
          
        });
  }

  limpiar()
  {
  	this.auxCartera=[];
  }

  calcularTotal(item){
    item.pagar = (item.cantidad >0);
  }
}



// WEBPACK FOOTER //
// ./src/pages/cartera/cartera.ts